var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col sm:w-1/1 w-full" },
          [
            _c("label", [_vm._v("Empregador:")]),
            _c(
              "vx-input-group",
              { staticClass: "mb-2" },
              [
                _c("vs-input", {
                  staticClass: "required",
                  attrs: { disabled: "", value: _vm.companyName }
                }),
                _c("template", { slot: "append" }, [
                  _c(
                    "div",
                    { staticClass: "append-text btn-addon" },
                    [
                      _c("vs-button", {
                        attrs: {
                          color: "primary",
                          type: "border",
                          icon: "search",
                          title: "Buscar"
                        },
                        on: {
                          click: function($event) {
                            _vm.showEmployerSearchGrid = true
                          }
                        }
                      }),
                      _c("vs-button", {
                        attrs: {
                          color: "primary",
                          type: "border",
                          icon: "add",
                          title: "Incluir"
                        },
                        on: {
                          click: function($event) {
                            return _vm.openEmployerCreateForm()
                          }
                        }
                      }),
                      _c("vs-button", {
                        attrs: {
                          color: "primary",
                          type: "border",
                          icon: "clear",
                          title: "Limpar"
                        },
                        on: {
                          click: function($event) {
                            _vm.occupation.employer = null
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              2
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col sm:w-1/2 w-full mb-2" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-full required",
              attrs: { type: "text", label: "Profissão" },
              model: {
                value: _vm.occupation.name,
                callback: function($$v) {
                  _vm.$set(_vm.occupation, "name", $$v)
                },
                expression: "occupation.name"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col sm:w-1/2 w-full mb-2" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: ["####"],
                  expression: "['####']"
                }
              ],
              staticClass: "w-full",
              attrs: { type: "text", label: "Tempo Profissão (anos)" },
              model: {
                value: _vm.occupation.occupation_time,
                callback: function($$v) {
                  _vm.$set(_vm.occupation, "occupation_time", $$v)
                },
                expression: "occupation.occupation_time"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col sm:w-1/2 w-full mb-2" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "money",
                  rawName: "v-money",
                  value: _vm.money,
                  expression: "money"
                }
              ],
              ref: "gross_income",
              staticClass: "w-full input-text-align-right",
              attrs: { label: "Renda Bruta" },
              model: {
                value: _vm.occupation.gross_income,
                callback: function($$v) {
                  _vm.$set(_vm.occupation, "gross_income", $$v)
                },
                expression: "occupation.gross_income"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col sm:w-1/2 w-full mb-2" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "money",
                  rawName: "v-money",
                  value: _vm.money,
                  expression: "money"
                }
              ],
              ref: "equity_value",
              staticClass: "w-full input-text-align-right",
              attrs: { label: "Valor Patrimonial" },
              model: {
                value: _vm.occupation.equity_value,
                callback: function($$v) {
                  _vm.$set(_vm.occupation, "equity_value", $$v)
                },
                expression: "occupation.equity_value"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full" },
          [
            _c(
              "vs-button",
              {
                staticClass: "mt-5 float-right",
                attrs: { type: "border", disabled: !_vm.validateForm },
                on: { click: _vm.save }
              },
              [_vm._v("Salvar")]
            )
          ],
          1
        )
      ]),
      _c(
        "vs-popup",
        {
          attrs: { title: "Empregador", active: _vm.showEmployerSearchGrid },
          on: {
            "update:active": function($event) {
              _vm.showEmployerSearchGrid = $event
            }
          }
        },
        [
          _c("Grid", {
            attrs: {
              service: _vm.services.legalEntityService,
              route_name: "legal_entities",
              hide_actions: "true",
              delegate: _vm.employerSelected
            }
          })
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: {
            fullscreen: "",
            title: "Cadastrar Empregador / Pessoa Jurídica",
            active: _vm.showEmployerCreateForm
          },
          on: {
            "update:active": function($event) {
              _vm.showEmployerCreateForm = $event
            }
          }
        },
        [
          _c("LegalEntityForm", {
            attrs: {
              services: _vm.services,
              legalEntityId: null,
              simpleCreation: true
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }